import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Form from './views/Form.vue';
import store from './store';

Vue.use(Router);

const meta = {
  title: `${store.state.title}`,
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:slug',
      name: 'home',
      component: Home,
      meta,
    },
    {
      path: '/:slug/update-info',
      name: 'updateInfo',
      component: Form,
      props: {
        winner_type: 'update_info',
      },
      meta,
    },
    {
      path: '/:slug/advertise',
      name: 'advertise',
      component: Form,
      props: {
        winner_type: 'advertise',
      },
      meta,
    },
  ],
});
